<template>
  <div class="text-lg text-center mx-0 my-auto md:text-2xl lg:text-3xl">
    <div class="px-2 m-auto md:px-20 lg:px-40 prose prose-lg" v-html="htmlText"></div>
  </div>
</template>

<script lang="ts">
import { IContext } from '@/store/modules/common/types';
import { Vue, Component, Prop } from 'vue-property-decorator';
import showdown from 'showdown';

@Component
export default class TextSlide extends Vue {
  @Prop({ type: Object, default: () => {} }) content!: IContext;

  get htmlText(): string {
    const converter = new showdown.Converter({
      simpleLineBreaks: true,
      openLinksInNewWindow: true
    });
    return converter.makeHtml(this.content.value);
  }
}
</script>
